// @core/api/endpoints/platform/accept_federation_peer.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  AcceptFederationPeerRequest,
  FederationPeerResponse,
} from '../../../types/platform';

const BASE_PATH = '/platform';

/**
 * Accept federation peering
 * Accepts a pending federation peering request. The connection becomes active and catalog sync begins based on the configured trust level.
 */
export async function AcceptFederationPeer(
  peer_id: string,
  data: AcceptFederationPeerRequest,
  options?: RequestOptions
): Promise<FederationPeerResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/federation/peers/:peer_id/accept`;
  requestPath = requestPath.replace(':peer_id', encodeURIComponent(peer_id));
  const requestOptions = options;
  return client.post<FederationPeerResponse>(requestPath, data, requestOptions);
}
